var map = {
	"./": 136,
	"./Clutch": 2641,
	"./Clutch.js": 2641,
	"./NewUi": 2642,
	"./NewUi.js": 2642,
	"./OldUi": 2643,
	"./OldUi.js": 2643,
	"./index": 136,
	"./index.js": 136,
	"./style": 848,
	"./style.js": 848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4140;